// extracted by mini-css-extract-plugin
module.exports = {"cards":"_2AF-zb0yiLK8MC5Br_cXhi"};